/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import { GlobalState } from '../../actions';

export const playlistStatisticSelector = (state: GlobalState) => { return state.playlistAdmin.statistics.statistic; };